import type { ComponentType, ReactElement } from "react";
import React from "react";
import { injectIntl } from "react-intl";

import { ContextProvider } from "../components/shared/ContextProvider";
import { store as createStore } from "../components/stores/store";
import type { localizedMessages } from "../locales";
import { defaultLocale } from "../locales";

// Rails's react_component() always provides those props:
interface ContextProps {
  locale: keyof typeof localizedMessages;
  betaFeatures: ReadonlyArray<string>;
  currentUrl: string;
}

type PropsWithoutIntl<Props> = Props extends { intl: any } ? Omit<Props, "intl"> : Props;

export function createElement<Props>(
  component: ComponentType<Props>,
  props: PropsWithoutIntl<Props> & Partial<ContextProps>,
  store: any = createStore(), // default is only used in testing
): ReactElement {
  const contextProps = props as any as ContextProps;

  // In client, `store` is a singleton instance
  // In server, `store` is a per-component instance (see hypernova.ts)

  const locale = contextProps.locale || defaultLocale;
  const betaFeatures = contextProps.betaFeatures || [];
  const currentUrl = contextProps.currentUrl || "";

  return React.createElement(
    ContextProvider,
    { betaFeatures, currentUrl, store, locale },
    React.createElement(injectIntl(component as any), props as any),
  );
}
